/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import {
    REQUEST_ASSET,
    RECEIVE_ASSET,
    RECEIVE_ASSET_ERROR,
    CLEAR_ASSET
} from "./AssetActions";

const initialState = {
    details: null,
    error: null,
    loading: false,
}

export const asset = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_ASSET:
            return {
                ...state,
                loading: true,
            }
        case RECEIVE_ASSET:
            return {
                ...state,
                loading: false,
                details: action.asset,
                error: null,
            }
        case RECEIVE_ASSET_ERROR:
            return {
                ...state,
                loading: false,
                error: action.error.errorKey,
            }
        case CLEAR_ASSET:
            return initialState
        default:
            return state
    }
}